<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { cubicOut, cubicIn } from 'svelte/easing';
  import { scale, fly, slide } from 'svelte/transition';

  import { cssTextToObj, isMobile } from '../../etc/utils';
  import { useModal } from '../../etc/hooks/useModal';
  import { AppState } from '../../etc/stores';

  import Close from '../icons/Close.svelte';

  export let showCloseButton = true;

  const positionSettings = $AppState.settings || {};

  const dispatch = createEventDispatcher();

  const { close } = useModal();

  const onClose = () => {
    dispatch('close');
    close();
  };

  const flyWithScale: typeof fly = (node, params) => {
    const flyTrans = fly(node, params);
    const scaleTrans = scale(node, params);

    return {
      duration: params.duration,
      easing: params.easing,
      css: (t, u) => {
        const { transform: flyTransform, opacity: flyOpacity } = cssTextToObj(
          flyTrans.css(t, u)
        );
        const { transform: scaleTransform } = cssTextToObj(
          scaleTrans.css(t, u)
        );

        return `
          transform: ${flyTransform} ${scaleTransform};
          opacity: ${flyOpacity};
        `;
      }
    };
  };

  const inAnimation = (node: Element, params?: any) => {
    if (isMobile()) {
      return slide(node);
    }

    return flyWithScale(node, {
      ...defaultTransitionConfig,
      easing: cubicOut,
      duration: 500
    });
  };

  const outAnimation = (node: Element, params?: any) => {
    if (isMobile()) {
      return slide(node);
    }

    return flyWithScale(node, {
      ...defaultTransitionConfig,
      easing: cubicIn,
      duration: 400
    });
  };

  $: defaultTransitionConfig = {
    x:
      ((positionSettings.position === 'bottomRight' ? 1 : -1) *
        window.innerWidth) /
      2,
    y: window.innerHeight / 2
  };
</script>

<div class="twism-rounded-modal" in:inAnimation out:outAnimation>
  {#if showCloseButton}
    <div class="twism-rounded-modal-close" on:click={onClose}>
      <Close fill={$AppState.theme.colors.typography} />
    </div>
  {/if}
  <slot />
</div>

<style lang="scss">
  .twism-rounded-modal {
    box-shadow: 0px 14px 48px -13px rgba(4, 33, 67, 0.26);
    border-radius: 20px;
    background: #ffffff;
    position: relative;

    &-close {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
      user-select: none;
      z-index: 10;
      opacity: 0.3;
    }

    @media screen and (max-width: 468px) {
      position: absolute;
      width: 100%;
      height: 84%;
      bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
</style>
